<template>
    <div id="body-wrap" class="bg-main">
        <LayoutMainHeader/>
        <Main/>
    </div>
</template>

<script>
import { $WC } from "@/conf/common.const";
import LayoutMainHeader from '@/views/layout/LayoutMainHeader.vue'
import Main from '@/views/main/Main.vue'

export default {
    name: 'MainApp',
    created() {
        // 재난 안전 (5분 마다 조회)
        this.$store.dispatch('FETCH_SAFETY_LIST');
        setInterval(() => {
            this.$store.dispatch('FETCH_SAFETY_LIST');
        }, $WC.FIVE_MIN_INTERVAL);

        // 돌발 상황(5분 마다 조회)
        this.$store.dispatch('FETCH_ACCIDENT_LIST');
        setInterval(() => {
            this.$store.dispatch('FETCH_ACCIDENT_LIST');
        }, $WC.FIVE_MIN_INTERVAL);

        // 코로나 현황
        this.$store.dispatch('FETCH_COVID_STATE');

        // 날씨정보 (10분 마다 조회)
        this.$store.dispatch('FETCH_AIRSPACE');
        setInterval(() => {
            this.$store.dispatch('FETCH_AIRSPACE');
        }, $WC.TEN_MIN_INTERVAL);

        // 행정동 대기 정보 (10분 마다 조회)
        this.$store.dispatch('FETCH_AIR_HJD_LIST');
        setInterval(() => {
            this.$store.dispatch('FETCH_AIR_HJD_LIST');
        }, $WC.TEN_MIN_INTERVAL);

        // 상수도 수질 정보
        /*
        this.$store.dispatch('FETCH_LASTEST_WATER_QUALITY_LIST');
        setInterval(() => {
            this.$store.dispatch('FETCH_LASTEST_WATER_QUALITY_LIST');
        }, $WC.TEN_MIN_INTERVAL);
        */

        // 행정동 별 인구
        this.$store.dispatch("FETCH_HJD_POPULATION_LIST");

        // 물가 정보
        this.$store.dispatch("FETCH_PRICE_INFO")
            .then(() => {
                this.$eventBus.$emit('MainApp::loaded-price-info-data');
            });

        // 재정 세부사업별 예산현액 및 지출액 목록
        this.$store.dispatch('FETCH_EXPENDITURE_LIST');
        // 재정 세입내역
        this.$store.dispatch('FETCH_REVENUE_LIST');
    },
    components: {
        LayoutMainHeader,
        Main,
    }
}
</script>
